<!--
 * @Author: lsr lsr@qq.com
 * @Date: 2022-07-09 11:46:07
 * @LastEditors: lsr lsr@qq.com
 * @LastEditTime: 2022-07-09 14:03:46
 * @FilePath: \YHB_H5\src\pages\download\sysdownload.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="download-content">
        <syCom v-if="device == 'h5'"></syCom>
        <syPcCom v-else></syPcCom>
    </div>
</template>

<script>
import syCom from './com/syCom.vue';
import syPcCom from './com/syPcCom.vue';

export default {
    data() {
        return {
            device: 'h5',
            // 定义监听器
            changeSize:null
        };
    },
    created() {
        this.isPc();
        // 监听屏幕大小变化
        this.changeSize = window.addEventListener('resize', () => {
            this.isPc();
        });
    },
    methods: {
        // 判断h5和px
        isPc() {
            let client = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
            if (client) {
                this.device = 'h5';
            } else {
                this.device = 'pc';
            }
        },
    },
    components: {
        syCom,
        syPcCom
    },
    beforeDestroy() {
        // 销毁监听器
        window.removeEventListener('resize', this.changeSize);
    },
};
</script>

<style scoped>
	#app {
		height: 100%;
	}
	.download-content {
		height: 100%;
	}
</style>
